import { Injectable } from '@angular/core';

import { viagensRoute } from "./data.service";
import { AuthService } from "../../shared/services/auth.service";

@Injectable()
export class ViagemService {

    constructor(
        private _authService: AuthService
    ) { }

    goToSetting() {
        let router: string = viagensRoute + '/configuracoes';
        this._authService.navigateTo(router);
    }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/viagens/shared/viagem.service.ts
 **/